import { render, staticRenderFns } from "./Formation.vue?vue&type=template&id=cadb7daa&scoped=true"
import script from "./Formation.vue?vue&type=script&lang=js"
export * from "./Formation.vue?vue&type=script&lang=js"
import style0 from "./Formation.vue?vue&type=style&index=0&id=cadb7daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadb7daa",
  null
  
)

export default component.exports